/*! @azure/msal-browser v3.6.0 2023-12-01 */
'use strict';
/* eslint-disable header/header */
const name = "@azure/msal-browser";
const version = "3.6.0";

export { name, version };
//# sourceMappingURL=packageMetadata.mjs.map
